/* LongstoneTruck v.1.0 — interazioni del tema (vanilla, modulo ES).
   Si appoggia agli eventi standard di Shopify usati da Horizon, così carrello laterale e contatori restano allineati. */
import { CartLinesUpdateEvent, StandardEvents } from '@shopify/events';

const $ = (s, r = document) => r.querySelector(s);
const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
const money = (cents, cur) => {
  const c = cur || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
  const n = (cents / 100).toLocaleString('it-IT', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return c === 'EUR' ? '€' + n : n + ' ' + c;
};

/* ---------- Mega menu ---------- */
function initMega() {
  const root = $('[data-lst-mega-root]');
  if (!root) return;
  const btns = $$('[data-lst-mega-btn]', root);
  let timer;
  const close = () => {
    btns.forEach((b) => b.setAttribute('aria-expanded', 'false'));
    $$('[data-lst-mega]', root).forEach((p) => (p.hidden = true));
  };
  const open = (i) => {
    close();
    const b = btns.find((x) => x.dataset.lstMegaBtn === i);
    const p = $(`[data-lst-mega="${i}"]`, root);
    if (!b || !p) return;
    b.setAttribute('aria-expanded', 'true');
    p.hidden = false;
  };
  btns.forEach((b) => {
    b.addEventListener('mouseenter', () => { clearTimeout(timer); timer = setTimeout(() => open(b.dataset.lstMegaBtn), 80); });
    b.addEventListener('click', () => (b.getAttribute('aria-expanded') === 'true' ? close() : open(b.dataset.lstMegaBtn)));
  });
  root.addEventListener('mouseleave', () => { clearTimeout(timer); timer = setTimeout(close, 150); });
  root.addEventListener('mouseenter', () => clearTimeout(timer));
  $$('[data-lst-mega-close]', root).forEach((x) => x.addEventListener('click', close));
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
}

/* ---------- Drawer menu mobile ---------- */
function initDrawer() {
  const d = $('[data-lst-drawer]');
  if (!d) return;
  const opener = $('[data-lst-drawer-open]');
  const set = (on) => {
    d.classList.toggle('is-open', on);
    d.setAttribute('aria-hidden', on ? 'false' : 'true');
    opener && opener.setAttribute('aria-expanded', on ? 'true' : 'false');
    document.documentElement.style.overflow = on ? 'hidden' : '';
  };
  opener && opener.addEventListener('click', () => set(true));
  $$('[data-lst-drawer-close]', d).forEach((x) => x.addEventListener('click', () => set(false)));
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') set(false); });
}

/* ---------- Contatore carrello in header ---------- */
function renderHeaderCart(cart) {
  if (!cart) return;
  const qty = cart.totalQuantity ?? cart.item_count;
  const total = cart.cost ? Math.round(parseFloat(cart.cost.totalAmount.amount) * 100) : cart.total_price;
  const cur = cart.cost ? cart.cost.totalAmount.currencyCode : cart.currency;
  $$('[data-lst-cart-count]').forEach((el) => (el.textContent = qty));
  if (total != null) $$('[data-lst-cart-total]').forEach((el) => (el.textContent = money(total, cur)));
}
function initCartCounter() {
  document.addEventListener(StandardEvents.cartLinesUpdate, (e) => {
    e.promise?.then(({ cart }) => renderHeaderCart(cart)).catch(() => {});
  });
  window.addEventListener('pageshow', (e) => {
    if (e.persisted) fetch('/cart.js').then((r) => r.json()).then(renderHeaderCart).catch(() => {});
  });
}

/* ---------- Aggiunta al carrello (stesso protocollo del product-form di Horizon) ---------- */
function cartSectionIds() {
  return $$('cart-items-component').map((el) => el.dataset.sectionId).filter(Boolean);
}
async function addToCart(source, items, { context = 'product' } = {}) {
  let resolve, reject;
  const promise = new Promise((res, rej) => { resolve = res; reject = rej; });
  source.dispatchEvent(new CartLinesUpdateEvent({
    action: 'add', context,
    lines: items.map((i) => ({ merchandiseId: String(i.id), quantity: i.quantity || 1 })),
    promise,
  }));
  try {
    const res = await fetch((window.Theme?.routes?.cart_add_url || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items, sections: cartSectionIds().join(',') }),
    });
    const data = await res.json();
    const cart = await fetch('/cart.js').then((r) => r.json());
    const qty = items.reduce((a, i) => a + (i.quantity || 1), 0);
    resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: { items: cart.items, source: 'lst', itemCount: qty, sections: data.sections, didError: !!data.status },
    });
    if (data.status) throw new Error(data.description || data.message || 'Errore');
    return data;
  } catch (err) {
    reject(err);
    throw err;
  }
}

function initProductForms() {
  $$('form[data-lst-product-form]').forEach((form) => {
    if (form.dataset.lstBound) return;
    form.dataset.lstBound = '1';
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = $('[type="submit"]', form);
      const msg = $('[data-lst-form-msg]', form);
      if (btn && btn.disabled) return;
      const fd = new FormData(form);
      const id = fd.get('id');
      if (!id) return;
      const properties = {};
      for (const [k, v] of fd.entries()) {
        const m = k.match(/^properties\[(.+)\]$/);
        if (m && v !== '') properties[m[1]] = v;
      }
      const item = { id: Number(id), quantity: Number(fd.get('quantity') || 1) };
      if (Object.keys(properties).length) item.properties = properties;
      const label = btn ? btn.innerHTML : '';
      if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
      if (msg) msg.hidden = true;
      try {
        await addToCart(form, [item]);
        if (btn) btn.innerHTML = 'Aggiunto al carrello <span aria-hidden="true">✓</span>';
        setTimeout(() => { if (btn) btn.innerHTML = label; }, 1800);
      } catch (err) {
        if (msg) { msg.textContent = err.message; msg.hidden = false; }
      } finally {
        if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); }
        form.dispatchEvent(new CustomEvent('lst:variant-check', { bubbles: true }));
      }
    });
  });
  if (initProductForms.done) return;
  initProductForms.done = true;
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-lst-quick-add]');
    if (!b) return;
    e.preventDefault();
    b.disabled = true;
    const t = b.innerHTML;
    try {
      await addToCart(b, [{ id: Number(b.dataset.lstQuickAdd), quantity: 1 }], { context: 'upsell' });
      b.innerHTML = 'Aggiunto ✓';
    } catch (err) {
      b.innerHTML = 'Riprova';
    }
    setTimeout(() => { b.innerHTML = t; b.disabled = false; }, 1800);
  });
}

/* ---------- Varianti, quantità e galleria in scheda prodotto ---------- */
function initProduct() {
  $$('[data-lst-product]').forEach((root) => {
    if (root.dataset.lstBound) return;
    root.dataset.lstBound = '1';
    const form = $('form[data-lst-product-form]', root);
    const dataEl = $('script[data-lst-variants]', root);
    const variants = dataEl ? JSON.parse(dataEl.textContent) : [];
    const idInput = form && $('input[name="id"]', form);
    const btn = form && $('[type="submit"]', form);
    const btnLabel = btn && $('[data-lst-btn-label]', btn);
    const priceEl = $('[data-lst-price]', root);
    const compareEl = $('[data-lst-compare]', root);
    const optLabels = $$('[data-lst-opt-label]', root);
    const groups = $$('[data-lst-option]', root);

    const update = () => {
      if (!groups.length) return;
      const sel = groups.map((g) => { const c = $('input:checked', g); return c ? c.value : null; });
      optLabels.forEach((l, i) => { l.textContent = sel[i] ? `${l.dataset.name}: ${sel[i]}` : `Seleziona ${l.dataset.name.toLowerCase()}`; });
      groups.forEach((g, gi) => {
        $$('input', g).forEach((inp) => {
          const test = sel.slice(); test[gi] = inp.value;
          const ok = variants.some((v) => v.available && v.options.every((o, oi) => test[oi] == null || o === test[oi] || oi === gi && o === inp.value));
          inp.parentElement.classList.toggle('is-out', !ok);
        });
      });
      if (sel.some((s) => s == null)) {
        if (btn) { btn.disabled = true; btnLabel && (btnLabel.textContent = `Scegli ${groups[sel.findIndex((s) => s == null)].dataset.name.toLowerCase()}`); }
        return;
      }
      const v = variants.find((x) => x.options.every((o, i) => o === sel[i]));
      if (!v) { if (btn) { btn.disabled = true; btnLabel && (btnLabel.textContent = 'Non disponibile'); } return; }
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      if (compareEl) { compareEl.textContent = v.compare_at_price > v.price ? money(v.compare_at_price) : ''; }
      if (btn) { btn.disabled = !v.available; btnLabel && (btnLabel.textContent = v.available ? 'Aggiungi al carrello' : 'Esaurito'); }
      const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
      if (v.featured_media_index != null) showImg(root, v.featured_media_index);
    };
    groups.forEach((g) => g.addEventListener('change', update));
    root.addEventListener('lst:variant-check', update);
    update();

    $$('[data-lst-qty]', root).forEach((q) => {
      const inp = $('input', q);
      q.addEventListener('click', (e) => {
        const b = e.target.closest('button'); if (!b) return;
        const n = Math.max(1, (parseInt(inp.value, 10) || 1) + (b.dataset.step === '+' ? 1 : -1));
        inp.value = n;
      });
    });

    const thumbs = $$('[data-lst-thumb]', root);
    thumbs.forEach((t) => t.addEventListener('click', () => showImg(root, Number(t.dataset.lstThumb))));
    const step = (d) => {
      const n = thumbs.length; if (n < 2) return;
      const cur = Number(root.dataset.lstImg || 0);
      showImg(root, (cur + d + n) % n, d);
    };
    $$('[data-lst-gal-step]', root).forEach((b) => b.addEventListener('click', () => step(Number(b.dataset.lstGalStep))));
    /* Swipe orizzontale sull'immagine principale (mobile) */
    const main = $('.lst-gal__main', root);
    if (main && thumbs.length > 1) {
      let x0 = null, y0 = null;
      main.addEventListener('touchstart', (e) => { const t = e.touches[0]; x0 = t.clientX; y0 = t.clientY; }, { passive: true });
      main.addEventListener('touchend', (e) => {
        if (x0 === null) return;
        const t = e.changedTouches[0]; const dx = t.clientX - x0; const dy = t.clientY - y0;
        x0 = y0 = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.2) step(dx < 0 ? 1 : -1);
      }, { passive: true });
    }
  });
}
function showImg(root, i, dir = 0) {
  const thumbs = $$('[data-lst-thumb]', root);
  const main = $('.lst-gal__main img', root);
  const t = thumbs[i];
  if (!t || !main) return;
  if (dir && main.animate && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
    main.animate([{ transform: `translateX(${dir * 24}px)`, opacity: 0.4 }, { transform: 'none', opacity: 1 }], { duration: 220, easing: 'ease-out' });
  }
  root.dataset.lstImg = i;
  thumbs.forEach((x, k) => x.setAttribute('aria-current', k === i ? 'true' : 'false'));
  main.src = t.dataset.full; main.srcset = t.dataset.srcset || ''; main.alt = t.dataset.alt || '';
  const c = $('[data-lst-counter]', root); if (c) c.textContent = `${i + 1} / ${thumbs.length}`;
}

/* ---------- Filtri collezione / ricerca ---------- */
function initFilters() {
  $$('form[data-lst-filters]').forEach((f) => {
    f.addEventListener('change', (e) => {
      if (e.target.matches('[data-lst-price-input]')) return;
      submitFilters(f);
    });
    $$('[data-lst-price-input]', f).forEach((i) => i.addEventListener('change', () => submitFilters(f)));
  });
  $$('select[data-lst-sort]').forEach((s) => s.addEventListener('change', () => {
    const url = new URL(location.href); url.searchParams.set('sort_by', s.value); url.searchParams.delete('page'); location.href = url.toString();
  }));
  $$('[data-lst-filter-toggle]').forEach((b) => b.addEventListener('click', () => {
    const l = b.closest('[data-lst-layout]') || $('[data-lst-layout]');
    const on = !l.classList.contains('is-filters-open');
    l.classList.toggle('is-filters-open', on); b.setAttribute('aria-expanded', on);
  }));
}
function submitFilters(f) {
  const params = new URLSearchParams(new FormData(f));
  for (const [k, v] of Array.from(params.entries())) if (v === '') params.delete(k);
  const keep = new URL(location.href).searchParams;
  ['q', 'sort_by', 'type', 'options[prefix]'].forEach((k) => { if (keep.get(k) && !params.has(k)) params.set(k, keep.get(k)); });
  location.href = `${location.pathname}?${params.toString()}`;
}

/* ---------- Tab prodotti in home ---------- */
function initTabs() {
  $$('[data-lst-tabs]').forEach((root) => {
    const tabs = $$('[role="tab"]', root);
    tabs.forEach((t) => t.addEventListener('click', () => {
      tabs.forEach((x) => { const on = x === t; x.setAttribute('aria-selected', on); x.classList.toggle('on', on); });
      $$('[role="tabpanel"]', root).forEach((p) => (p.hidden = p.id !== t.getAttribute('aria-controls')));
    }));
  });
}

/* ---------- Etichette in maiuscolo nei testi ricchi (es. VEICOLI COMPATIBILI) ---------- */
function initRichLabels() {
  $$('.lst-rich p').forEach((p) => {
    const st = p.querySelector('strong');
    const t = p.textContent.trim();
    if (st && t === st.textContent.trim() && t.length > 2 && t === t.toUpperCase()) p.classList.add('lst-lab');
  });
}

/* ---------- Filtro punti vendita per autostrada ---------- */
function initStoreFilter() {
  $$('[data-lst-store-filter]').forEach((root) => {
    const chips = $$('[data-road]', root);
    chips.forEach((c) => c.addEventListener('click', () => {
      chips.forEach((x) => x.classList.toggle('on', x === c));
      chips.forEach((x) => x.setAttribute('aria-pressed', x === c ? 'true' : 'false'));
      const r = c.dataset.road;
      $$('[data-store-road]', root).forEach((card) => { card.hidden = r !== 'all' && card.dataset.storeRoad !== r; });
    }));
  });
}

/* ---------- Carica altri prodotti senza ricaricare la pagina ---------- */
function initLoadMore() {
  document.addEventListener('click', async (e) => {
    const a = e.target.closest('[data-lst-load-more]');
    if (!a) return;
    e.preventDefault();
    if (a.getAttribute('aria-busy') === 'true') return;
    a.setAttribute('aria-busy', 'true');
    try {
      const html = await fetch(a.href).then((r) => r.text());
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const grid = $('[data-lst-grid]');
      $$('[data-lst-grid] > .lst-gi', doc).forEach((n) => grid.appendChild(document.importNode(n, true)));
      const more = $('[data-lst-more]');
      const nmore = $('[data-lst-more]', doc);
      if (more && nmore) more.replaceWith(document.importNode(nmore, true));
      history.replaceState({}, '', a.href);
    } catch (err) {
      location.href = a.href;
    }
  });
}

/* ---------- Spedizione indicativa nel carrello (tariffa reale Shopify per l'Italia) ---------- */
function initShipEstimate() {
  const Q = 'shipping_address%5Bcountry%5D=Italy&shipping_address%5Bzip%5D=00100&shipping_address%5Bprovince%5D=RM';
  const cache = {};
  const busy = {};
  const ssGet = (k) => { try { const v = sessionStorage.getItem('lst-ship-' + k); return v === null ? undefined : JSON.parse(v); } catch (e) { return undefined; } };
  const ssSet = (k, v) => { try { sessionStorage.setItem('lst-ship-' + k, JSON.stringify(v)); } catch (e) {} };
  const render = (el, cents) => {
    const val = $('[data-lst-ship-value]', el);
    if (cents === null || cents === undefined) { el.hidden = true; return; }
    const sub = Number(el.dataset.subtotal), thr = Number(el.dataset.threshold), max = Number(el.dataset.freeMax);
    const free = cents === 0 || (sub >= thr && cents <= max);
    val.classList.remove('is-pending');
    val.textContent = free ? 'Gratis' : money(cents);
    el.classList.toggle('is-free', free);
    const bar = el.closest('cart-items-component, .cart-drawer__inner, main')?.querySelector('[data-lst-ship-bar]') || $('[data-lst-ship-bar]');
    if (bar && cents > max) {
      bar.classList.add('is-bulky');
      const t = $('.lst-cx-bar__t', bar);
      if (t) t.innerHTML = 'Merce ingombrante: spedizione <strong>' + money(cents) + '</strong>, esclusa dalla spedizione gratuita';
    }
  };
  const poll = (n) => new Promise((r) => setTimeout(r, 400))
    .then(() => fetch('/cart/async_shipping_rates.json?' + Q, { credentials: 'same-origin' }))
    .then((r) => (r.status === 200 ? r.json() : null))
    .then((d) => {
      if (d && d.shipping_rates) {
        const prices = d.shipping_rates.map((s) => Math.round(parseFloat(s.price) * 100));
        return prices.length ? Math.min(...prices) : null;
      }
      return n < 12 ? poll(n + 1) : null;
    });
  const run = () => {
    const drawer = document.getElementById('cart-drawer');
    $$('[data-lst-ship]').forEach((el) => {
      const inDrawer = drawer && drawer.contains(el);
      if (inDrawer && !drawer.hasAttribute('open')) return;
      const key = el.dataset.key;
      if (!(key in cache)) { const s = ssGet(key); if (s !== undefined) cache[key] = s; }
      if (el.dataset.done === key) return;
      if (key in cache) { el.dataset.done = key; render(el, cache[key]); return; }
      if (busy[key]) return;
      busy[key] = true;
      fetch('/cart/prepare_shipping_rates.json?' + Q, { method: 'POST', credentials: 'same-origin' })
        .then(() => poll(0))
        .catch(() => null)
        .then((cents) => {
          cache[key] = cents; ssSet(key, cents); delete busy[key];
          $$('[data-lst-ship]').forEach((e2) => { if (e2.dataset.key === key) { e2.dataset.done = key; render(e2, cents); } });
        });
    });
  };
  const drawer = document.getElementById('cart-drawer');
  if (drawer) new MutationObserver(run).observe(drawer, { attributes: true, attributeFilter: ['open'], childList: true, subtree: true });
  run();
}

/* ---------- Memoria locale: prodotti visti e ricerche recenti ---------- */
const store = {
  get(k) { try { return JSON.parse(localStorage.getItem(k) || '[]'); } catch (e) { return []; } },
  set(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} },
};
const RV_KEY = 'lst-rv', RS_KEY = 'lst-rs';
function initRecentlyViewed() {
  const el = $('script[data-lst-rv]');
  if (!el) return;
  let p;
  try { p = JSON.parse(el.textContent); } catch (e) { return; }
  if (!p || !p.h) return;
  const list = store.get(RV_KEY).filter((x) => x && x.h !== p.h);
  list.unshift(p);
  store.set(RV_KEY, list.slice(0, 10));
}
const saveSearch = (q) => {
  q = String(q || '').trim();
  if (q.length < 2) return;
  const list = store.get(RS_KEY).filter((x) => typeof x === 'string' && x.toLowerCase() !== q.toLowerCase());
  list.unshift(q);
  store.set(RS_KEY, list.slice(0, 6));
};

/* ---------- Ricerca live (Predictive Search API di Shopify) ---------- */
function initPredictiveSearch() {
  $$('form[data-lst-search]').forEach((form) => {
    if (form.dataset.lstBound) return;
    form.dataset.lstBound = '1';
    const input = $('[data-lst-search-input]', form);
    const box = $('[data-lst-ps]', form);
    if (!input || !box) return;
    const phFull = input.placeholder, phShort = input.dataset.phMobile;
    if (phShort) {
      const mq = matchMedia('(max-width: 900px)');
      const setPh = () => { input.placeholder = mq.matches ? phShort : phFull; };
      setPh(); mq.addEventListener ? mq.addEventListener('change', setPh) : mq.addListener(setPh);
    }
    const esc = (t) => String(t ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
    const eur = (v) => money(Math.round(parseFloat(v) * 100));
    const img = (u, w) => (u ? u + (u.includes('?') ? '&' : '?') + 'width=' + w : '');
    let timer, ctrl, hideT, last = '', cache = {}, mode = '';
    const dim = $('[data-lst-ps-dim]');
    const zeroTpl = $('template[data-lst-ps-zero]', form);
    const open = () => {
      clearTimeout(hideT);
      if (box.hidden) { box.hidden = false; void box.offsetWidth; }
      box.classList.add('is-in');
      dim?.classList.add('is-on');
      input.setAttribute('aria-expanded', 'true');
    };
    const close = () => {
      box.classList.remove('is-in');
      dim?.classList.remove('is-on');
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
      mode = '';
      clearTimeout(hideT);
      hideT = setTimeout(() => { if (!box.classList.contains('is-in')) box.hidden = true; }, 180);
    };
    const renderZero = () => {
      const rv = store.get(RV_KEY).filter((x) => x && x.h && !location.pathname.endsWith('/products/' + x.h)).slice(0, 8);
      const rs = store.get(RS_KEY).filter((x) => typeof x === 'string').slice(0, 6);
      let h = '';
      if (rv.length) h += '<div class="lst-ps__grp"><p class="lst-ps__lab">Continua ad acquistare</p><div class="lst-ps__rv">' +
        rv.map((p) => '<a class="lst-ps__rvc" role="option" href="' + esc(p.u) + '">' +
          (p.i ? '<img src="' + esc(img(p.i, 240)) + '" alt="" width="120" height="120" loading="lazy">' : '<span class="lst-ps__ph"></span>') +
          '<span class="lst-ps__t">' + esc(p.t) + '</span><span class="lst-ps__p">' + (p.v ? '<span style="font-weight:400;color:var(--lst-mut)">da </span>' : '') + esc(p.p) + '</span></a>').join('') + '</div></div>';
      if (rs.length) h += '<div class="lst-ps__grp"><div class="lst-ps__head"><p class="lst-ps__lab">Ricerche recenti</p><button type="button" class="lst-ps__clear" data-lst-rs-clear>Cancella</button></div><div class="lst-ps__chips">' +
        rs.map((q) => '<span class="lst-ps__rs"><a class="lst-ps__chip" role="option" href="' + esc(allUrl(q)) + '" data-lst-ps-q="' + esc(q) + '">' +
          '<svg aria-hidden="true" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>' + esc(q) + '</a>' +
          '<button type="button" class="lst-ps__del" data-lst-rs-del="' + esc(q) + '" aria-label="Rimuovi ' + esc(q) + ' dalle ricerche recenti">×</button></span>').join('') + '</div></div>';
      if (zeroTpl) h += zeroTpl.innerHTML;
      if (!h.trim()) { close(); return; }
      box.innerHTML = h;
      $$('[role="option"]', box).forEach((el, i) => (el.id = 'lst-ps-o' + i));
      mode = 'zero';
      open();
    };
    const allUrl = (q) => form.action + '?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last';
    const render = (q, r) => {
      const qs = (r.queries || []).filter((x) => x.text.toLowerCase() !== q.toLowerCase()).slice(0, 4);
      const seen = new Set();
      const cols = (r.collections || []).filter((c) => { const k = c.title.trim().toLowerCase(); if (seen.has(k)) return false; seen.add(k); return true; }).slice(0, 3);
      const prods = r.products || [];
      let h = '';
      if (qs.length) h += '<div class="lst-ps__grp"><p class="lst-ps__lab">Suggerimenti</p><div class="lst-ps__chips">' +
        qs.map((x) => '<a class="lst-ps__chip" role="option" href="' + esc(x.url) + '">' + (x.styled_text || esc(x.text)) + '</a>').join('') + '</div></div>';
      if (cols.length) h += '<div class="lst-ps__grp"><p class="lst-ps__lab">Categorie</p>' +
        cols.map((c) => '<a class="lst-ps__col" role="option" href="' + esc(c.url) + '"><span>' + esc(c.title) + '</span><span>→</span></a>').join('') + '</div>';
      if (prods.length) h += '<div class="lst-ps__grp"><p class="lst-ps__lab">Prodotti</p>' + prods.map((p) => {
        const im = p.featured_image && p.featured_image.url;
        const cmp = parseFloat(p.compare_at_price_max) > parseFloat(p.price) ? '<s>' + eur(p.compare_at_price_max) + '</s>' : '';
        const from = p.price_max && p.price_min !== p.price_max ? '<span style="font-weight:400;color:var(--lst-mut)">da </span>' : '';
        return '<a class="lst-ps__row" role="option" href="' + esc(p.url) + '">' +
          (im ? '<img src="' + esc(img(im, 120)) + '" alt="" width="56" height="56" loading="lazy">' : '<span class="lst-ps__ph"></span>') +
          '<span>' + (p.vendor && !/longstone/i.test(p.vendor) ? '<span class="lst-ps__v" style="display:block">' + esc(p.vendor) + '</span>' : '') + '<span class="lst-ps__t">' + esc(p.title) + '</span></span>' +
          '<span class="lst-ps__p">' + from + eur(p.price) + cmp + '</span></a>';
      }).join('') + '</div>';
      if (!prods.length && !cols.length && !qs.length) h += '<p class="lst-ps__empty">Nessun risultato per “' + esc(q) + '”. Prova con il modello del camion o il codice prodotto.</p>';
      h += '<a class="lst-ps__all" role="option" href="' + esc(allUrl(q)) + '"><span>Vedi tutti i risultati per “' + esc(q) + '”</span><span aria-hidden="true">→</span></a>';
      box.innerHTML = h;
      $$('[role="option"]', box).forEach((el, i) => (el.id = 'lst-ps-o' + i));
      mode = 'results';
      open();
    };
    const run = async () => {
      const q = input.value.trim();
      if (q.length < 2) { last = ''; if (document.activeElement === input) renderZero(); else close(); return; }
      if (q === last && !box.hidden) return;
      last = q;
      if (cache[q]) { render(q, cache[q]); return; }
      ctrl?.abort();
      ctrl = new AbortController();
      form.classList.add('is-loading');
      try {
        const url = '/search/suggest.json?q=' + encodeURIComponent(q) +
          '&resources[type]=product,collection,query&resources[limit]=6&resources[limit_scope]=each' +
          '&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.sku,variants.title,vendor,tag';
        const d = await fetch(url, { signal: ctrl.signal }).then((r) => r.json());
        const r = (d.resources && d.resources.results) || {};
        cache[q] = r;
        if (input.value.trim() === q) render(q, r);
      } catch (e) {
        if (e.name !== 'AbortError') close();
      } finally {
        form.classList.remove('is-loading');
      }
    };
    input.addEventListener('input', () => { clearTimeout(timer); timer = setTimeout(run, 180); });
    input.addEventListener('focus', () => { if (input.value.trim().length >= 2) { last = ''; run(); } else renderZero(); });
    input.addEventListener('click', () => { if (box.hidden || !box.classList.contains('is-in')) { if (input.value.trim().length >= 2) { last = ''; run(); } else renderZero(); } });
    form.addEventListener('submit', () => saveSearch(input.value));
    box.addEventListener('click', (e) => {
      const del = e.target.closest('[data-lst-rs-del]');
      if (del) {
        e.preventDefault();
        const q = del.dataset.lstRsDel.toLowerCase();
        store.set(RS_KEY, store.get(RS_KEY).filter((x) => String(x).toLowerCase() !== q));
        renderZero(); input.focus(); return;
      }
      if (e.target.closest('[data-lst-rs-clear]')) { e.preventDefault(); store.set(RS_KEY, []); renderZero(); input.focus(); return; }
      const qa = e.target.closest('[data-lst-ps-q]');
      if (qa) { saveSearch(qa.dataset.lstPsQ); return; }
      const chip = e.target.closest('.lst-ps__chip');
      if (chip) { saveSearch(chip.textContent); return; }
      if (e.target.closest('.lst-ps__all')) saveSearch(input.value);
    });
    input.addEventListener('keydown', (e) => {
      const opts = $$('[role="option"]', box);
      if (e.key === 'Escape') { close(); return; }
      if (box.hidden || !opts.length || !['ArrowDown', 'ArrowUp', 'Enter'].includes(e.key)) return;
      let i = opts.findIndex((o) => o.getAttribute('aria-selected') === 'true');
      if (e.key === 'Enter') { if (i >= 0) { e.preventDefault(); opts[i].click(); } return; }
      e.preventDefault();
      if (i >= 0) opts[i].removeAttribute('aria-selected');
      i = e.key === 'ArrowDown' ? (i + 1) % opts.length : (i <= 0 ? opts.length - 1 : i - 1);
      opts[i].setAttribute('aria-selected', 'true');
      opts[i].scrollIntoView({ block: 'nearest' });
      input.setAttribute('aria-activedescendant', opts[i].id);
    });
    document.addEventListener('click', (e) => { if (!form.contains(e.target)) close(); });
    form.addEventListener('focusout', (e) => { if (e.relatedTarget && !form.contains(e.relatedTarget)) close(); });
  });
}

const init = () => { initMega(); initDrawer(); initCartCounter(); initProductForms(); initProduct(); initFilters(); initTabs(); initRichLabels(); initStoreFilter(); initLoadMore(); initShipEstimate(); initRecentlyViewed(); initPredictiveSearch(); };
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
document.addEventListener('shopify:section:load', () => { initPredictiveSearch(); initMega(); initDrawer(); initProductForms(); initProduct(); initTabs(); });
